const isValidDate = date => {
  return date instanceof Date && !isNaN(date.getTime())
}

const formatDate = (date, type) => {
  const year = date.getFullYear()
  const month =
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  if (type === 1) {
    return `${year}-${month}-${day}`
  } else {
    return `${year}年${month}月${day}日`
  }
}
export { isValidDate, formatDate }
